/**
 * Reducer for obtaining flight routes
 */
import Constants from '../constants/RoutesConstants';
import { fromJS, List as IList } from 'immutable';

const initialState = null;

/**
 * ## auth function
 * @param {Object} state - initialState
 * @param {Object} action - type and data
 */
export default function routes (state = initialState, action = null) {
  switch (action.type) {
    /**
     * ### REQUESTS (start)
     */
    case Constants.ROUTES_REQUEST:
      return null;

    /**
     * ### SUCCESS (request ended with success)
     */
    case Constants.ROUTES_SUCCESS:
      return fromJS(action.data);

    /**
     * ### FAILURE (request ended with error)
     */
    case Constants.ROUTES_FAILURE:
      return IList();

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/RoutesReducer.js